<script lang="ts">
    /**
     * User https://oembed.com/ to fetch data embed data from youtube or vimeo.
     */
    import { onMount } from 'svelte';

    export let url: string;
    let data;
    let html: string;

    onMount(async () => {
        const urlObj = new URL(url);
        if (['vimeo.com', 'www.vimeo.com'].includes(urlObj.host)) {
            const resp = await fetch(
                `https://vimeo.com/api/oembed.json?url=${url}&width=1920&height=1080`
            );
            if (resp.ok) {
                // console.log({ vimeoResp: resp });
                data = await resp.json();
                html = data.html;
            }
        } else if (['youtube.com', 'www.youtube.com'].includes(urlObj.host)) {
            const resp = await fetch(`https://www.youtube.com/oembed?url=${url}&format=json`);
            if (resp.ok) {
                // console.log({ ytResp: resp });
                data = await resp.json();
                html = data.html;
            }
        }
    });
</script>

{#if html}
    <section>
        {@html html}
    </section>
{/if}

<style lang="scss">
    section {
        :global(iframe) {
            width: 100%;
            aspect-ratio: 16/9;
            height: min-content;
        }
    }
</style>
